//export const BASE_URL = 'http://localhost:3000';
export const BASE_URL = 'https://api.anahee.in';
